import api from '@/js/services/axios'
import dateUtil from '@/js/utils/dateUtil'
import urlUtil from '@/js/utils/urlUtil'

export const EVENT_TYPES = {
  SINGLE: 'single',
  RECURRING: 'recurring'
}

export default {
  getMyEvents (startDate, endDate, filters = {}) {
    var queryMap = new Map()
    if (!startDate){  
      startDate = Date.now()
    }
    if (!endDate){
      endDate = Date.now() + 365 * 24 * 60 * 60 * 1000
    }

    queryMap.set('start_date', dateUtil.formatDateForSystem(startDate))
    queryMap.set('end_date', dateUtil.formatDateForSystem(endDate))
    
    // For client-side filtering, request all events (use large page size)
    // Only pass participant and membership filters to server
    if (filters.participantId) {
      queryMap.set('participant_id', filters.participantId)
    }
    if (filters.membershipId) {
      queryMap.set('membership_id', filters.membershipId)
    }
    
    // Request all events for client-side filtering (use large page size)
    queryMap.set('page', 0)
    queryMap.set('size', 1000) // Large enough to get all events
    
    var query = urlUtil.prepareQuery(queryMap)

    return new Promise((resolve, reject) => {
      api.get('private/v1/org/{orgId}/events' + query)
        .then(response => {
          var data = response.data
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getMyUpcommingEvents () {
    return new Promise((resolve, reject) => {
      api.get('private/v1/org/{orgId}/events/soon')
        .then(response => {
          var data = response.data
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPreparedEvents () {
    return new Promise((resolve, reject) => {
      api.get('private/v1/org/{orgId}/events/prepare-events')
        .then(response => {
          var data = response.data
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  

  createEvent (eventList){
    return new Promise((resolve, reject) => {
      
      let requestBody = []
      eventList.forEach(myEvent => {
        let eventTime = dateUtil.toDateFromDateTime(myEvent.startDate, myEvent.startTime);
        
        requestBody.push({
          class_id: myEvent.rClassId,
          start_time: eventTime.toISOString(),
          event_configuration: myEvent.event_configuration,
          trainer: myEvent.trainer,
        })
      });

      api.post('private/v1/org/{orgId}/events', 
        requestBody)
        .then(response => {
          var data = response.data
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  /** What cancelling would do: `{ recipient_count, pending_payment_count }`. */
  getCancelPreview (eventId){
    return new Promise((resolve, reject) => {
      api.get('private/v1/org/{orgId}/events/' + eventId + '/cancel-preview')
        .then(response => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  cancelEvent (eventId, cancelReason){
    return new Promise((resolve, reject) => {
      api.post('private/v1/org/{orgId}/events/' + eventId + '/cancel', 
        {
          cancel_reason: cancelReason
        })
        .then(response => {
          var data = response.data
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  deleteEvent (eventId){
    return new Promise((resolve, reject) => {
      api.delete('private/v1/org/{orgId}/events/' + eventId)
        .then(response => {
          let status = response.status
          if (status >= 200 && status < 300){
            resolve()
          } else 
            throw new Error('Failed to deleting event')
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
